/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {campaignCommons} from "../campaign/campaign-commons";
import {LineItemReviewResource} from '../../components/api/resources/resource/line-item.resource';
import {emptyRouteView} from '../common/directives/html/route-view-components';

const listTemplate = '<adn-ax-review-list-page [list]="list"></adn-ax-review-list-page>';

export function axReviewStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterHelper('ax-reviews.ax-review', LineItemReviewResource, 'app.adv', 'app', listTemplate);
    
        $stateProvider.state(rh.listPath(), rh.list({
          resolve: {
            bulk: function() {
              return {};
            },
            listConfig: function() {
              return {pageSize: 5, moreParams: {excludeIfMissing: 'axProductId', filterBy: 'userState', filterByValue: 'SUBMITTED'}};
            },
            extension: /*@ngInject*/ function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();

              return {
                func: function(ctrl) {
                  campaignCommons(ctrl).setUpComponents(['items']);
                  ctrl.hasCreativeCopyright = LocalNetworkProfile.isCreativeCopyrightStatus();
                }
              };
            }
          },
          views: {
            'context@app': emptyRouteView()
          }
        }, "LineItemReview", [{type: 'Advertiser', func: 'isNotSelfService'}, {type: 'Order', func: 'isNotSelfService'}]));
  }, adnRouterHelper);
}
